<template>
    <div class="md:pl-10 w-full md:w-3/4 md:pr-10">
        <h1 class="mb-6">Duplicate Event</h1>

        <div class="mb-12">
            <label for="festival" ref="festival">
                Select Event Calendar <span class="text-red">*</span>
            </label>
            <p class="mb-6">Make a copy of <strong>{{ event.title }}</strong> in the festival you select below:</p>
            <select id="festival" name="festival" ref="festival"
                v-model="festivalId"
                v-validate="'required'">
                <option :value="null" disabled>Select an event calendar</option>
                <option
                    v-for="festival in currentFestivals"
                    :key="festival.id"
                    :value="festival.id">{{ festival.title }} {{festival.datesTitle}}</option>
            </select>
            <span v-if="errors.has('festival')" class="error text-error-red text-lg">
              {{ errors.first('festival').replaceAll('festival', 'event calendar') }}
            </span>
        </div>

        <p class="mb-6">
            <button @click.stop.prevent="duplicateEvent" class="button mb-12">Duplicate</button>
        </p>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import messaging from "../../../mixins/messaging";
    import validation from "../../../mixins/validation";

    export default {
        name: "EventCreateDuplicate",
        title: "Duplicate Event",
        mixins: [messaging, validation],
        data: () => ({
            eventErrors: [],
            festivalId: null,
        }),
        computed: {
            ...mapGetters({
                event: "event",
                festivals: "festivals",
                isLoading: "isLoading",
                user: "user"
            }),
            currentFestivals() {
                return _.filter(this.festivals, { isInPast: false });
            },
        },
        watch: {
            event(event) {
                if (!event.festival.isInPast) {
                    this.festivalId = event.festival.id;
                }
            }
        },
        methods: {
            duplicateEvent() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.gotoFirstValidationError();
                        return;
                    }

                    let route = this.$laroute.route("api.events.duplicate", {
                        event: this.event.id
                    });

                    axios
                        .post(route, { festival_id: this.festivalId })
                        .then(response => {
                            this.$toasted.show("Event has been duplicated");
                            let event = response.data.data;

                            this.$router.push({
                                name: "events-basics",
                                params: { id: event.id }
                            });
                            window.scroll(0, 0);
                        })
                        .catch(error => {
                            this.displayError(error);
                        });
                });
            }
        },
        mounted() {
            this.$store.dispatch("getEvent", { id: this.$route.params.id });
            this.$store.dispatch("getFestivals");
        }
    };
</script>
